"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-page-header", {
    attrs: {
      title: "返回"
    },
    on: {
      back: _vm.goBack
    }
  }), _vm._v(" "), _c("el-dialog", {
    attrs: {
      title: "修改产品",
      visible: _vm.dialogFormVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("GoodForm", {
    attrs: {
      isEdit: true,
      pk: _vm.pk,
      is_day_nums: _vm.is_day_nums
    },
    on: {
      "edit-good": _vm.editGood,
      cancel: _vm.cancel
    }
  })], 1), _vm._v(" "), _c("el-row", [_c("el-card", {
    staticStyle: {
      padding: "10px 0",
      "margin-top": "10px"
    }
  }, [_c("div", {
    staticClass: "clearfix",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("span", {
    staticStyle: {
      "margin-left": "20px",
      "font-weight": "600",
      "font-size": "20px",
      "margin-right": "20px"
    }
  }, [_vm._v("产品信息")]), _vm._v(" "), _c("el-button", {
    attrs: {
      icon: "el-icon-refresh-right",
      size: "small",
      type: "success"
    },
    on: {
      click: _vm.getList
    }
  }, [_vm._v("刷新页面")]), _vm._v(" "), _c("el-button", {
    staticClass: "filter-item",
    staticStyle: {
      float: "right",
      "margin-right": "10px"
    },
    attrs: {
      type: "primary",
      icon: "el-icon-edit",
      size: "small"
    },
    on: {
      click: _vm.handleEdit
    }
  }, [_vm._v("修改产品信息")])], 1), _vm._v(" "), _c("el-row", {
    staticStyle: {
      padding: "10px 20px"
    },
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.document,
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "产品名称"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.name,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "name", $$v);
      },
      expression: "document.name"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "创建时间"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.create_time,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "create_time", $$v);
      },
      expression: "document.create_time"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.document.order_type === 2,
      expression: "document.order_type === 2"
    }],
    attrs: {
      label: "产品分类"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.main_class,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "main_class", $$v);
      },
      expression: "document.main_class"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "编号"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.sequence,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "sequence", $$v);
      },
      expression: "document.sequence"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "产品二维码(通用)"
    }
  }, [_c("el-image", {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      src: _vm.qrImg
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "扣费方式"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.document.cost_type === 1 ? "天" : _vm.document.cost_type === 2 ? "月" : "周") + "\n            ")]), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "下单方式"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.document.order_mode === 1 ? "先用后付" : "先付后用") + "\n            ")]), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "上架状态"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.active,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "active", $$v);
      },
      expression: "document.active"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "成本金额"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.cost_money,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "cost_money", $$v);
      },
      expression: "document.cost_money"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "下单类型"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.document.order_type === 1 ? "缴费" : "租赁") + "\n            ")]), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "扣款总额"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.money,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "money", $$v);
      },
      expression: "document.money"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.document.order_type === 2,
      expression: "document.order_type === 2"
    }],
    attrs: {
      label: "扣款期数"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.cost_num,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "cost_num", $$v);
      },
      expression: "document.cost_num"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.document.order_type === 2,
      expression: "document.order_type === 2"
    }],
    attrs: {
      label: "首次扣款天数"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.document.q_cost_day ? _vm.document.q_cost_day : "暂无") + "(天)\n            ")]), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.document.order_type === 2,
      expression: "document.order_type === 2"
    }],
    attrs: {
      label: "扣款规则"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      disabled: ""
    },
    model: {
      value: _vm.document.cost_rule,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "cost_rule", $$v);
      },
      expression: "document.cost_rule"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.document.order_type === 2,
      expression: "document.order_type === 2"
    }],
    attrs: {
      label: "买断开关"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.document.d_cost_type === 1 ? "开启" : "关闭") + "\n            ")]), _vm._v(" "), _c("el-form-item", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.document.d_cost_money,
      expression: "document.d_cost_money"
    }],
    attrs: {
      label: "买断价格"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.document.d_cost_money,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "d_cost_money", $$v);
      },
      expression: "document.d_cost_money"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "备注提示信息"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.document.remark) + "\n            ")]), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "商品参数名称"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.document.parameter == "无" ? "" : _vm.document.parameter) + "\n            ")]), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "商品备选参数"
    }
  }, [_vm._v("\n             " + _vm._s(_vm.document.parameter_value) + "\n            ")])], 1)], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", [_vm._v("产品图片"), _c("span", {
    staticStyle: {
      "font-size": "14px",
      color: "red"
    }
  }, [_vm._v("（点击预览大图）")])]), _vm._v(" "), _c("el-image", {
    staticStyle: {
      width: "80%",
      height: "80%",
      "margin-top": "15px",
      "margin-bottom": "15px"
    },
    attrs: {
      src: _vm.good_img,
      "preview-src-list": _vm.srcList
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;